const ACCENTED: Record<string, string> = {
  a: "à", b: "ƀ", c: "ç", d: "ð", e: "é", f: "ƒ", g: "ĝ", h: "ĥ", i: "î", j: "ĵ", k: "ķ", l: "ļ", m: "ɱ",
  n: "ñ", o: "ö", p: "þ", r: "ŕ", s: "š", t: "ţ", u: "û", w: "ŵ", y: "ý", z: "ž",
  A: "Å", C: "Ç", D: "Ð", E: "É", I: "Î", N: "Ñ", O: "Ö", S: "Š", U: "Û", Y: "Ý",
};

export const pseudoLocalise = (value: string) =>
  `[${value.replace(/[A-Za-z]/g, letter => ACCENTED[letter] ?? letter)}${"·".repeat(Math.ceil(value.length / 3))}]`;
